import { render, staticRenderFns } from "./IssueSolutionItem.vue?vue&type=template&id=442c9350&scoped=true"
import script from "./IssueSolutionItem.vue?vue&type=script&lang=js"
export * from "./IssueSolutionItem.vue?vue&type=script&lang=js"
import style0 from "./IssueSolutionItem.vue?vue&type=style&index=0&id=442c9350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442c9350",
  null
  
)

export default component.exports